import { useSearchParams } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

import { useExpensesNavigation } from 'modules/expenses/hooks/useExpensesNavigation'

import type { ExpensableGroup } from './types'

interface DetailProps {
  id: string
  effectiveOn: string
  amount: ExpensableGroup['amount']
  currency: ExpensableGroup['currency']
  owner?: ExpensableGroup['owner']
}

export const Detail = ({ id, amount, currency, effectiveOn, owner }: DetailProps) => {
  const { navigation } = useExpensesNavigation()
  const [searchParams] = useSearchParams()
  const {
    access: { locale },
  } = useCurrentSession()

  const amountToShow = currency
    ? MoneyWithCurrency({
        optionalDecimals: true,
        amount: Number(amount),
        currency,
        locale,
      })
    : 0

  return (
    <Button.Router
      aria-label={i18n.t('expenses_v2.list.actions.see_group_details_with_owner', {
        amount: amountToShow,
        date: dateBackendDateTimeToUI(effectiveOn),
        ownerName: owner?.access?.fullName,
      })}
      to={{
        pathname: navigation.groups.id.fullPath({ groupId: id }),
        search: searchParams.toString(),
      }}
      type="secondary"
      iconName="arrow-right"
    />
  )
}
